import styled from "styled-components"

export const StyledGallery = styled.div`
  margin: 0px 50px;
  .ant-image {
    margin: 15px;
    width: 200px;
  }
`
